import companyApi from "../api/company";
import { ICompany } from "../components/admin/Company";
import { CompanyFeatures } from "../utilities/companyUtilities";
import { useFetch } from "./useApi";

export interface IUserCompany {
  id: number;
  name: string;
  role: string;
  parentRole: string;
  features: CompanyFeatures;
  subdomain?: string;
  website?: string;
}

export class UserCompany implements IUserCompany {
  id = 0;
  name = "";
  role = "";
  parentRole = "";
  features = new CompanyFeatures([]);
  subdomain;
  website;

  private constructor(company: ICompany | IUserCompany | null) {
    if (company) {
      this.id = company.id;
      this.name = company.name;
      this.role = company.role;
      this.parentRole = company.parentRole;
      this.subdomain = company.subdomain;
      this.website = company.website;

      this.features = Array.isArray(company.features)
        ? new CompanyFeatures(company.features ?? [])
        : company.features;
    }
  }

  static get EMPTY(): UserCompany {
    return UserCompany.create(null);
  }

  static create(company: ICompany | IUserCompany | null): UserCompany {
    return new UserCompany(company);
  }

  static clone(company: IUserCompany): UserCompany {
    return UserCompany.create(company);
  }
}

export const useCompanies = (): UserCompany[] => {
  const { data } = useFetch(companyApi.get);

  const companies = data?.companies?.map((c: any) => UserCompany.create(c)) || [];
  return companies;
};
